export default "__VITE_PUBLIC_ASSET__bb42f6bf__"